import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import {
  ICloseItemParams,
  ICreateItemParams,
  IGetStagesResponse,
  Item,
  IUpdateItemParams,
  OpportunitiesSort,
  Stage,
} from './interfaces';
import {
  IDeleteResourceResponse,
  IGetResourceResponse,
  IMessageOnlyResponse,
  IPaginatedResourceEndpointResponse,
  IUpsertResourceResponse,
} from '../interfaces';
import { FilterFields } from '../../components/ManagedDataTable/interfaces';
import {
  getFiltersEndpointParams,
  getPaginatedEndpointParams,
} from '../helpers';

export const getStages = async (options?: {
  includeItems?: boolean;
  filters?: FilterFields;
}): Promise<Stage[]> => {
  const response: AxiosResponse<IGetStagesResponse> = await apiClient.get(
    '/opportunities/stages',
    {
      params: {
        include: options?.includeItems ? 'items' : undefined,
        filters: options?.filters
          ? getFiltersEndpointParams(options.filters)
          : [],
      },
    }
  );

  return response.data.data;
};

export const updateItem = async (
  itemId: number,
  itemData: IUpdateItemParams
): Promise<number> => {
  const response: AxiosResponse<IUpsertResourceResponse> = await apiClient.put(
    `/opportunities/items/${itemId}`,
    JSON.stringify(itemData),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data.data.id;
};

export const closeItem = async (
  itemId: number,
  closeData: ICloseItemParams
): Promise<void> => {
  await apiClient.put(
    `/opportunities/items/${itemId}/close`,
    JSON.stringify(closeData),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

export const createItem = async (
  itemData: ICreateItemParams
): Promise<number> => {
  const response: AxiosResponse<IUpsertResourceResponse> = await apiClient.post(
    '/opportunities/items',
    itemData
  );

  return response.data.data.id;
};

export const deleteItem = async (id: number): Promise<void> => {
  const response: AxiosResponse<IDeleteResourceResponse> =
    await apiClient.delete(`/opportunities/items/${id}`);
};

export const getOpportunities = async (
  page: number,
  pageSize: number,
  sort?: OpportunitiesSort,
  search?: string,
  filters?: FilterFields
): Promise<IPaginatedResourceEndpointResponse<Item>> => {
  const response: AxiosResponse<IPaginatedResourceEndpointResponse<Item>> =
    await apiClient.get('/opportunities/items', {
      params: getPaginatedEndpointParams({
        page,
        perPage: pageSize,
        sort,
        search,
        filters,
      }),
    });

  return response.data;
};

export const getItem = async (id: number): Promise<Item> => {
  const response: AxiosResponse<IGetResourceResponse<Item>> =
    await apiClient.get(`/opportunities/items/${id}`);

  return response.data.data;
};
